import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyProfile = lazy(() => import('./Profile.tsx'));

export const Profile: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyProfile {...props} />
	</Suspense>
);
